module.exports = __webpack_public_path__ + "assets/images/wanchai-1OAtIlp.jpg";